
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/expense-tracker/security",
      function () {
        return require("private-next-pages/apps/expense-tracker/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/expense-tracker/security"])
      });
    }
  